import PropTypes from "prop-types";
import { Row } from "antd";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  fetchAccountData,
  updateActiveFlow,
  updateActivePage,
  updateActivePageStepNumber,
  updateStepperConfig
} from "../../../../actions/globalActions";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import { FixedWidth, PagesHeading } from "../../../../CommonComponents/commonStyles";
import { ContentMessage, ContentProvider, Types } from "../../../../CommonComponents/ContentMessages";
import { initiateTracking } from "../../../../utils/commonUtil";
import { getAccountData, getPrimaryAccount } from "../../../../utils/sessionUtil";
import { getZipCode, profileJsonTemp, updateActivePageStepName, updateDropdownValues } from "../../actions";
import ProfileForm from "./Components/ProfileForm";
import { PagesHeadingWrapper } from "./styles";
import Messages from "../../../../CommonComponents/Messages";

class EditProfile extends React.Component {
  constructor(props) {
    super(props);
    this.mainHeading = "Edit Profile";
    this.userType = "primary";
  }

  analyticsTracking(event, action, label) {
    initiateTracking(event, this.getPageTitle(), action, label);
  }

  componentDidMount() {
    const data = {
      metaData: {
        method: "GET",
        page: "EditProfile",
        url: {
          userDetails: `/donor-portal/api/profile/${
            getPrimaryAccount().userId
          }/getEditProfileByAccountIdAndPartyId?partyId=${getAccountData().partyId}`,
          dropDownValues: "/donor-portal/api/dropDownValues/getCodeValueMapping"
        }
      }
    };

    this.props.setActiveFlow("editProfileForm");
    this.props.setActivePage("editProfile");
    this.props.getOPABasicinfo(data);
    this.props.setActivePageStepNumber(1);
    this.props.setActivePageStepName("EditProfile");
  }

  setPageTitle = (title = "") => {
    if (title) {
      this.mainHeading = title;
    }
  };

  getPageTitle = () => {
    return this.mainHeading;
  };

  breadcrumbRoutes = () => {
    return [
      {
        routeName: "Home",
        path: "/"
      },
      {
        routeName: "My Profile",
        path: "/my-profile"
      },
      {
        routeName: () => (
          <ContentMessage
            type={[Types.PAGE_TITLE_DESCRIPTION]}
            page="Edit Profile"
            property="field_page_title"
            defaultMessage="Edit Profile"
          />
        ),
        path: "/my-profile/edit"
      }
    ];
  };

  render() {    
    return (
      <ContentProvider types={[Types.PAGE_TITLE_DESCRIPTION, Types.PAGE_ALERTS]} pages={["Edit Profile"]}>
        <FixedWidth>
          <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
          <PagesHeading marginBottom="50px">
            <ContentMessage
              type={[Types.PAGE_TITLE_DESCRIPTION]}
              page="Edit Profile"
              property="field_page_title"
              defaultMessage="Edit Profile"
              setTitle={this.setPageTitle}
            />
          </PagesHeading>
          <Messages/>
          <Row>
            <div className="infoMsg">All fields are required unless marked Optional.</div>
          </Row>
          <ProfileForm
            analyticsTracking={this.analyticsTracking.bind(this)}
            advisorType="Primary"
            userType={this.userType}
          />
        </FixedWidth>
      </ContentProvider>
    );
  }
}

const mapStateToProps = state => ({
  stepCount: state.getIn(["editProfile", "activePageStepName"]),
  stepNum: state.getIn(["globalState", "activePageStepNumber"]),
  isEdit: state.getIn(["editProfile", "isEdit", "isEdit", "isEdit"]),
  tempData: state.getIn(["editProfile", "tempJSON", "tempJSON"])
});

export const mapDispatchToProps = dispatch => ({
  setActiveFlow: flowName => dispatch(updateActiveFlow(flowName)),
  setActivePage: pageName => dispatch(updateActivePage(pageName)),
  setStepperConfig: config => dispatch(updateStepperConfig(config)),
  getOPABasicinfo: data => dispatch(fetchAccountData(data)),
  getZipCode: data => dispatch(getZipCode(data)),
  setActivePageStepNumber: stepNumber => dispatch(updateActivePageStepNumber(stepNumber)),
  setActivePageStepName: stepName => dispatch(updateActivePageStepName(stepName)),
  jsonTemp: val => dispatch(profileJsonTemp(val)),
  updateDropDownData: val => dispatch(updateDropdownValues(val))
});
EditProfile.propTypes = {
  getOPABasicinfo: PropTypes.func,
  setActiveFlow: PropTypes.func,
  setActivePage: PropTypes.func,
  setActivePageStepName: PropTypes.func,
  setActivePageStepNumber: PropTypes.func
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EditProfile));
